module.exports = __webpack_public_path__ + "img/24.ee83b8b5.jpg";